export default {
  styleOverrides: {
    root: {
      paddingTop: 16,
      paddingBottom: 0,
      paddingLeft: 24,
      paddingRight: 48,
      marginBottom: 0,
      fontWeight: 400,
    },
  },
};